// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__16AvW","header":"Messages_header__1Ir8h"};